import type { Coordinate } from '../types';

import { MEDIA_PROXY_BASEURL, ASSET_URL_WHITELIST } from '../constants';

/**
 * Calculates the distance between 2 points
 */
export function distance(point1: Coordinate, point2: Coordinate) {
    const xDistance = point1.x - point2.x;
    const yDistance = point1.y - point2.y;

    return Math.sqrt(xDistance * xDistance + yDistance * yDistance);
}

/**
 * Returns the median value
 * @param numbers - Array of Numbers
 * @returns - Median value
 */
export function median(numbers: Array<number>): number {
    // median of [3, 5, 4, 4, 1, 1, 2, 3] = 3
    let median = 0;
    const numsLen = numbers.length;

    numbers.sort();
    if (numsLen % 2 === 0) {
        median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
    }
    else {
        median = numbers[(numsLen - 1) / 2];
    }

    return median;
}

/**
 * Clamp the given value between the min and max value
 * @param value - Input value
 * @param minValue - Minimum value
 * @param maxValue - Maximum value
 * @returns - Clamped value
 */
export function clamp(value: number, minValue: number, maxValue: number): number {
    if (value < minValue) {
        return minValue;
    }
    if (value > maxValue) {
        return maxValue;
    }

    return value;
}

/**
 * Convert unicode to string
 * @param text - Unicode string
 * @returns - Converted unicode
 */
export function unicodeToChar(text: string): string {
    return text.replace(/\\u[\dA-F]{4}/gi,
        function(match) {
            return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
        });
}

export function maybeProxy(url: string) {
    if (typeof url !== 'string') {
        return url;
    }

    let shouldProxy = true;

    if (url.toLowerCase().startsWith('data:')) {
        shouldProxy = false;
    }

    if (url.startsWith(MEDIA_PROXY_BASEURL)) {
        shouldProxy = false;
    }

    // ensure we don't proxy local assets
    if (url.toLowerCase().startsWith('base/test/resources/images')) {
        shouldProxy = false;
    }

    if (shouldProxy === true) {
        for (let i = 0; i < ASSET_URL_WHITELIST.length; i++) {
            if (url.indexOf(ASSET_URL_WHITELIST[i]) >= 0) {
                shouldProxy = false;
                break;
            }
        }
    }

    if (shouldProxy === true) {
        url = MEDIA_PROXY_BASEURL + encodeURIComponent(url);
    }

    return url;
}
